import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck, Sparkles } from 'lucide-react';
export function CTASection() {
  return <Section id="precio" className="bg-[#003366] text-white text-center py-24" data-id="element-2">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-4xl mx-auto" data-id="element-3">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-4">
          <span className="text-slate-300" data-id="element-5">Si quieres dejar de traducir y</span>{' '}
          <br data-id="element-6" />
          <span className="bg-[#FF6600] text-white px-4 py-2 rounded-lg inline-block" data-id="element-7">
            empezar a responder
          </span>{' '}
          <span className="text-slate-300" data-id="element-8">como en USA:</span>
        </h2>

        <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-9">
          Consigue "Inglés Nativo en 14 Días (USA)" ahora. <br data-id="element-10" />
          Abre una escena hoy. Di el mini-guion 10 veces. <br data-id="element-11" />Y mañana vas a
          sonar diferente.
        </p>

        <motion.div id="precio-card" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-gradient-to-br from-[#002244] to-[#003366] border-2 border-[#FF6600]/30 rounded-3xl p-8 md:p-12 mb-8 max-w-2xl mx-auto relative overflow-hidden" data-id="element-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#FF6600]/5 rounded-full blur-3xl" data-id="element-13" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl" data-id="element-14" />

          <div className="relative z-10" data-id="element-15">
            <div className="inline-flex items-center space-x-2 bg-[#FF6600]/20 border border-[#FF6600]/50 rounded-full px-4 py-2 mb-6" data-id="element-16">
              <Sparkles className="w-4 h-4 text-[#FF6600]" data-id="element-17" />
              <span className="text-sm font-bold text-[#FF6600]" data-id="element-18">
                Oferta Especial
              </span>
            </div>

            <div className="mb-8" data-id="element-19">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-20">
                <span className="text-2xl text-slate-500 line-through" data-id="element-21">
                  $19.99
                </span>
                <div className="flex items-baseline" data-id="element-22">
                  <span className="text-6xl md:text-7xl font-bold text-[#FF6600]" data-id="element-23">
                    $6
                  </span>
                  <span className="text-4xl font-bold text-[#FF6600]" data-id="element-24">.39</span>
                </div>
              </div>
              <p className="text-slate-400 text-sm" data-id="element-25">
                Precio de lanzamiento - Por tiempo limitado
              </p>
            </div>

            <Button href="https://tuordendigital.com/cart/42033256103982:1" size="lg" className="text-xl px-12 py-8 w-full md:w-auto shadow-orange-500/20 shadow-2xl mb-6" onClick={() => {
            // Fire Meta Pixel AddToCart event
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Inglés Nativo en 14 Días',
                content_ids: ['42033256103982'],
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
          }} data-id="element-26">
              Obtener Acceso Inmediato
              <ArrowRight className="ml-2 w-6 h-6" data-id="element-27" />
            </Button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-slate-400" data-id="element-28">
              <div className="flex items-center" data-id="element-29">
                <ShieldCheck className="w-4 h-4 mr-2 text-[#99CC33]" data-id="element-30" />
                Pago seguro
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" data-id="element-31" />
              <div className="flex items-center" data-id="element-32">
                <ShieldCheck className="w-4 h-4 mr-2 text-[#99CC33]" data-id="element-33" />
                Descarga instantánea
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" data-id="element-34" />
              <div className="flex items-center" data-id="element-35">
                <ShieldCheck className="w-4 h-4 mr-2 text-[#99CC33]" data-id="element-36" />
                Acceso de por vida
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-slate-400 text-sm max-w-xl mx-auto" data-id="element-37">
          <p className="mb-2" data-id="element-38">✓ PDF completo con 20 escenas reales</p>
          <p className="mb-2" data-id="element-39">✓ Frases nativas + pronunciación</p>
          <p data-id="element-40">✓ Plan de mantenimiento 7 min/día</p>
        </motion.div>
      </motion.div>
    </Section>;
}